import React from 'react';
import methodModel from '../../../methods/methods';

const Html = ({
  inputElement,
  uploadImage,
  img,
  remove,
  loader,
  model,
  multiple,
  required,
  err,
  label = '',
}) => {
  return (
    <>
      <label
        className={`inline-block cursor-pointer text-white bg-[#A12238] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 ${
          img && !multiple ? 'd-none' : ''
        }`}
      >
        <input
          type="file"
          className="d-none"
          ref={inputElement}
          accept="image/*,.pdf"
          multiple={multiple ? true : false}
          disabled={loader}
          onChange={(e) => {
            uploadImage(e);
          }}
        />
        {label || 'Upload Image'}
      </label>

      {loader ? (
        <div className="text-success">
          Uploading... <i className="fa fa-spinner fa-spin"></i>
        </div>
      ) : (
        <></>
      )}

      {multiple ? (
        <>
          <div className="imagesRow imagesRow flex gap-4">
            {img &&
              img.map((itm, i) => {
                return (
                  <div className="imagethumbWrapper">
                    <img
                      src={methodModel.noImg(itm, model)}
                      className="thumbnail w-[120px] h-[120px] rounded-lg p-1 shadow-md object-contain"
                    />
                    <i
                      className="fa fa-times"
                      title="Remove"
                      onClick={(e) => remove(itm, img)}
                    ></i>
                  </div>
                );
              })}
          </div>
        </>
      ) : (
        <>
          {img ? (
            <div className="imagethumbWrapper">
              <img
                src={methodModel.noImg(img, model)}
                className="thumbnail w-[120px] h-[120px] rounded-lg p-1 shadow-md object-contain"
              />
              <i
                className="fa fa-times"
                title="Remove"
                onClick={(e) => remove(img)}
              ></i>
            </div>
          ) : (
            <></>
          )}
        </>
      )}

      {required && !img ? (
        <div className="text-danger">{err ? err : 'Image is Required'}</div>
      ) : (
        <></>
      )}
    </>
  );
};
export default Html;
